/*!
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ICategoriesHttpService } from './categories-http.service.interface';
import { IPlaceMapCategory } from '../../models';
import { environment } from '../../../../environments/environment';

@Injectable()
export class CategoriesHttpService implements ICategoriesHttpService {
  private readonly _rootUrl: string;

  constructor(private readonly _httpClient: HttpClient) {
    this._rootUrl = `${environment.config.endpoints.plotApiEndpoint}/v2`;
  }

  public getPlaceCategories(): Observable<IPlaceMapCategory[]> {
    return this._httpClient.get<IPlaceMapCategory[]>(`${this._rootUrl}/Category/MapCategories/`);
  }
}
